// Formulaire « Demandez à être contacté » : suivi, auto-complétion SIRET/NAF,
// validation et anti-spam. Soumission native vers backend/form.php.
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    var form = document.querySelector(".contact-form__form");
    if (!form) return;

    var cp = form.querySelector("#cp");
    var rsociale = form.querySelector("#rsociale");
    var tel = form.querySelector("#tel");
    var datalist = form.querySelector("#rsociale-list");
    var srcInput = form.querySelector("#src");
    var cmpInput = form.querySelector("#cmp_support");
    var siretInput = form.querySelector("#siret");
    var nafInput = form.querySelector("#naf");
    var captcha = form.querySelector("#captcha");

    // --- Suivi de campagne (levier / cmp_support depuis l'URL) ---
    var params = new URLSearchParams(window.location.search);
    srcInput.value = params.get("levier") || "organique";
    cmpInput.value = params.get("cmp_support") || "organique";

    // --- Raison sociale activée seulement quand le code postal est complet ---
    function toggleRsociale() {
      rsociale.disabled = !/^\d{5}$/.test(cp.value.trim());
    }
    cp.addEventListener("input", toggleRsociale);
    toggleRsociale();

    // --- Auto-complétion via l'API entreprises (recherche-entreprises.api.gouv.fr) ---
    var API = "https://recherche-entreprises.api.gouv.fr/search";

    function fetchCompanies(query) {
      var url =
        API +
        "?q=" +
        encodeURIComponent(query) +
        "&code_postal=" +
        encodeURIComponent(cp.value.trim()) +
        "&per_page=10";
      return fetch(url)
        .then(function (r) {
          return r.ok ? r.json() : { results: [] };
        })
        .catch(function () {
          return { results: [] };
        });
    }

    var debounceTimer;
    rsociale.addEventListener("input", function () {
      var q = rsociale.value.trim();
      if (rsociale.disabled || q.length < 3) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        fetchCompanies(q).then(function (data) {
          datalist.innerHTML = "";
          (data.results || []).forEach(function (el) {
            if (!el.nom_raison_sociale) return;
            var opt = document.createElement("option");
            opt.value = el.nom_raison_sociale;
            datalist.appendChild(opt);
          });
        });
      }, 300);
    });

    // Remplit SIRET / NAF à partir de la meilleure correspondance.
    rsociale.addEventListener("change", function () {
      var q = rsociale.value.trim();
      if (q.length < 3) return;
      fetchCompanies(q).then(function (data) {
        var results = data.results || [];
        if (!results.length) return;
        var match =
          results.filter(function (el) {
            return (
              el.nom_raison_sociale &&
              el.nom_raison_sociale.toLowerCase() === q.toLowerCase()
            );
          })[0] || results[0];
        var siege = match.siege || {};
        siretInput.value = siege.siret || "";
        nafInput.value = siege.activite_principale || "";
      });
    });

    // --- Validation ---
    function setError(input, message) {
      var field = input.closest(".field");
      var errEl = document.getElementById(input.id + "-error");
      if (message) {
        if (field) field.classList.add("field--invalid");
        if (errEl) errEl.textContent = message;
        input.setAttribute("aria-invalid", "true");
      } else {
        if (field) field.classList.remove("field--invalid");
        if (errEl) errEl.textContent = "";
        input.removeAttribute("aria-invalid");
      }
    }

    function validateField(input) {
      var value = input.value.trim();
      // Champ obligatoire vide : on marque l'état sans écrire de message. Le
      // soulignement rouge et aria-invalid portent l'information par champ, la
      // synthèse en tête de formulaire donne le compte. Répéter huit fois la
      // même phrase allongeait la carte sans rien apprendre de plus.
      if (input.required && !value) {
        setError(input, "");
        input.setAttribute("aria-invalid", "true");
        var f = input.closest(".field");
        if (f) f.classList.add("field--invalid");
        return false;
      }
      if (input === cp && !/^\d{5}$/.test(value)) {
        setError(input, "Code postal à 5 chiffres.");
        return false;
      }
      if (input === tel && !/^\d{10}$/.test(value)) {
        setError(input, "Numéro à 10 chiffres.");
        return false;
      }
      if (input.type === "email" && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        setError(input, "Adresse e-mail invalide.");
        return false;
      }
      if (input.type === "number" && value && Number(value) < 1) {
        setError(input, "Valeur invalide.");
        return false;
      }
      setError(input, "");
      return true;
    }

    var summary = document.getElementById("form-summary");
    var inputs = Array.prototype.slice.call(form.querySelectorAll("input[required]"));
    inputs.forEach(function (input) {
      input.addEventListener("blur", function () {
        validateField(input);
      });
    });

    // --- Soumission ---
    form.addEventListener("submit", function (e) {
      // Honeypot rempli => robot : on bloque silencieusement.
      if (captcha && captcha.value !== "") {
        e.preventDefault();
        return;
      }

      var firstInvalid = null;
      var manquants = 0;
      inputs.forEach(function (input) {
        var ok = validateField(input);
        if (!ok) {
          if (!firstInvalid) firstInvalid = input;
          // Un champ vide relève de la synthèse ; une erreur de format garde
          // son message propre, qui dit ce qu'il faut corriger.
          if (!input.value.trim()) manquants++;
        }
      });

      if (summary) {
        summary.textContent = manquants === 0 ? ""
          : manquants === 1 ? "Un champ obligatoire n'est pas rempli."
          : manquants + " champs obligatoires ne sont pas remplis.";
      }

      if (firstInvalid) {
        e.preventDefault();
        firstInvalid.focus();
      }
    });
  });
})();
